(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fa-home"] && !Shopify.designMode) return;
  try {
    

  function initFormAlltag(root) {
    if (!root || root.dataset.faReady) return;
    root.dataset.faReady = 'true';
    const controls = root.querySelector('.fa-filters');
    if (!controls) return;
    const cards = Array.from(root.querySelectorAll('[data-fa-category]'));
    const filters = Array.from(controls.querySelectorAll('[data-fa-filter]'));
    const showAll = root.querySelector('[data-fa-show-all]');
    const status = root.querySelector('[data-fa-filter-status]');
    const limit = Number(root.dataset.featuredCount) || 8;
    let active = 'all';
    let expanded = false;
    function apply(category, expand) {
      active = category;
      expanded = expand;
      let matching = 0;
      let visible = 0;
      cards.forEach(card => {
        const matches = category === 'all' || card.dataset.faCategory === category;
        const show = matches && (expand || matching < limit);
        if (matches) matching++;
        card.hidden = !show;
        if (show) visible++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faFilter === category)));
      if (showAll) showAll.hidden = matching <= visible;
      status.textContent = (status.dataset.label || '__shown__ / __total__').replace('__shown__', visible).replace('__total__', matching);
      root.querySelector('[data-fa-filter-empty]').hidden = matching !== 0;
    }
    function fromHash(scroll) {
      const match = window.location.hash.match(/^#kollektion-(alle|wohnen|ordnung|licht)$/);
      if (!match) return false;
      apply(match[1] === 'alle' ? 'all' : match[1], true);
      if (scroll) root.querySelector('#kollektion').scrollIntoView({ block: 'start', behavior: 'instant' });
      return true;
    }
    function selectCategory(category) {
      apply(category, true);
      const hash = '#kollektion-' + (category === 'all' ? 'alle' : category);
      if (window.location.hash !== hash) window.history.replaceState(window.history.state, '', hash);
    }
    filters.forEach(button => {
      const category = button.dataset.faFilter;
      if (category !== 'all' && !cards.some(card => card.dataset.faCategory === category)) button.hidden = true;
      button.addEventListener('click', () => selectCategory(category));
    });
    if (showAll) showAll.addEventListener('click', () => selectCategory(active));
    controls.hidden = cards.length === 0;
    if (!fromHash(false)) apply('all', false);
    window.addEventListener('hashchange', () => fromHash(true));
    if (window.location.hash.startsWith('#kollektion-')) requestAnimationFrame(() => fromHash(true));
  }
  document.querySelectorAll('.fa-home').forEach(initFormAlltag);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.fa-home').forEach(initFormAlltag));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-masthead"]) return;
  try {
    

  document.addEventListener('click',event=>{if(!(event.target instanceof Element))return;const link=event.target.closest('.fa-mobile-menu nav a');if(link)link.closest('details').open=false;});
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.fa-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
